<template>
<!-- 分页组件 -->
  <el-pagination class="page-box"
                 @size-change="handleSizeChange"
                 @current-change="handleCurrentChange"
                 background
                 :current-page.sync="childMsg.currentPage"
                 :page-sizes="[10, 20, 30, 40, 80, 100, 200]"
                 :page-size.sync="childMsg.pageSize"
                 layout="total, sizes, prev, pager, next, jumper"
                 :total="childMsg.total">
  </el-pagination>
</template>
<script>
  export default {
    name: 'Pagination',
    props: ['childMsg'],
    data() {
      return {}
    },
    created() {
    },
    methods: {
      handleSizeChange(val) {
        /**
         * 子传父
         * 参数1 父元素方法
         * 参数2 数据
         */
        this.$emit('callFather')
      },
      handleCurrentChange() {
        /**
         * 子传父
         * 参数1 父元素方法
         * 参数2 数据
         */
        this.$emit('callFather')
      }
    }
  }
</script>

<style>
  .page-box {
    margin: 10px auto;
  }
</style>



// WEBPACK FOOTER //
// src/module/cardManage/component/Pagination.vue